<template>
  <div class="menu-group">
      <h2 class="menu-group-title">
        {{ title }}
      </h2>

      <ul>
        <li class="item-container" v-for="item in menuItems" :key="item.name">
          <MenuItem :item="item" :showActions="false" :isTakeaway="false" />
        </li>
      </ul>
  </div>
</template>

<script>
  import MenuItem from 'components/order/menu-item';
  import Slice from 'mixins/slice';

  export default {
    name: 'EatInMenuGroupSlice',
    mixins: [Slice],
    components: { MenuItem },

    computed: {
      title () {
        return this.sliceData.groupTitle[0].text;
      },

      menuItems () {
        const items = this.slice.items.map(item => {

          return {
            name: item.menuGroupTitle,
            info: this.contentAsHtml(item.description),
            price: item.price
          }
        })

        return items;
      }
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .menu-group
    width: 100%
    max-width: 800px
    margin: 0 auto
    margin-bottom: 5em

  .menu-group-title
    @extend .t-subHeader
    margin-bottom: 2rem

  .item-container
    width: 100%
    position: relative
    padding: .6rem 0
    &:before
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )

  .item-container:last-of-type
    &:after
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )

</style>
